"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferType = void 0;
var OfferType;
(function (OfferType) {
    OfferType[OfferType["Managed"] = 0] = "Managed";
    OfferType[OfferType["Flexible"] = 1] = "Flexible";
    OfferType[OfferType["Pool"] = 2] = "Pool";
    OfferType[OfferType["DayTrip"] = 3] = "DayTrip";
    OfferType[OfferType["HourlyDriver"] = 4] = "HourlyDriver";
})(OfferType || (exports.OfferType = OfferType = {}));
//# sourceMappingURL=OfferType.js.map